import { FC } from 'react';
import { NavItem } from '@/types/nav-item';
import { NestedSidebarConfig } from '@/types/nested-sidebar-config';
import { NavLinks } from '../nav-links';
import { SidebarHead } from '../sidebar-head';

export type NestedSidebarLayout = {
  navItems: NavItem[];
  nestedConfig: NestedSidebarConfig;
};

export const NestedSidebarLayout: FC<NestedSidebarLayout> = ({
  navItems,
  nestedConfig,
}) => (
  <div className="flex h-full flex-row bg-secondaryShade">
    <div className="flex flex-col px-2.5">
      <SidebarHead className="justify-center" />
      <NavLinks darkVariant={true} iconOnly={true} items={navItems} />
    </div>

    <div className="flex w-72 flex-col bg-secondary">
      <div className="px-6">
        <SidebarHead
          className="border-b-0 pb-3"
          Icon={nestedConfig.Icon}
          iconClassName="w-6 h-6"
          title={nestedConfig.title}
          titleClassName="text-sm"
        />
      </div>
      {/* TODO: focus is not fully visible */}
      <div className="flex flex-col overflow-y-auto pb-4 pt-1">
        <div className="px-6">{nestedConfig.content}</div>
      </div>
    </div>
  </div>
);
